import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';

// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export const useInterval = (callback, delay) => {
  const $ = _c(6);
  const savedCallback = useRef(callback);
  let t0;
  let t1;
  if ($[0] !== callback) {
    t0 = () => {
      savedCallback.current = callback;
    };
    t1 = [callback];
    $[0] = callback;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== delay) {
    t2 = () => {
      const tick = () => {
        savedCallback.current();
      };
      if (delay !== null) {
        const id = window.setInterval(tick, delay);
        return () => window.clearInterval(id);
      }
      return _temp;
    };
    t3 = [delay];
    $[3] = delay;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
};
function _temp() {}